<template>
    <div>
        <div v-if="activateAddonInfo.length" class="active-addon-container" >
            <div>{{ $t('plpAddonsPage.buttonText') }}</div>
            <img :src="activateAddonInfo[0].icon.url" alt="mobile-icon">
            <div>{{ $t('plpAddonsPage.activateAddons') }}</div>
            <div v-for="(activeAddon, index) in addonText" :key="index" v-html="activeAddon"/>
        </div>
        <div v-else class="no-addon-activation">
            <img src="/assets/images/toast-icon-warning-desktop.svg" alt="warning-icon">
            {{ $t('plpAddonsPage.noAddonActivation') }}
        </div>
    </div>
</template>

<script>

export default {
  name: 'addon-modal-content',
  props: {
    activateAddonInfo: {
      type: Array
    }
  },
  computed: {
    addonText () {
      return this.$props.activateAddonInfo.map(addon => {
        if (addon.characteristicName && addon.characteristicName !== '') {
          return `-${addon.characteristicName}: ${addon.description}`
        }
        return addon.description ? `- ${addon.description}` : ''
      })
    }
  }
}

</script>

<style scoped lang="scss">

  .active-addon-container {
      text-align: center;
      div {
          margin: 15px 0;
          &:nth-of-type(1) {
            font-size: 24px;
            color: $dark;
          }
          &:nth-of-type(2) {
            font-size: 18px;
            color: $dark;
            font-weight: 600;
          }
        }
      img {
          margin: 15px 0;
      }
  }

  .no-addon-activation {
        text-align: center;
        margin-bottom: 20px;
        img {
            margin-right: 20px;
        }
    }

</style>
